import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import withCustomStyles from "./CategoryHorizontalTilePart.style";
import ImageWithLoaderPart from "./ImageWithLoaderPart";
import { getProductsPageUrl } from "../utils/UrlUtils";
import gtmService from "../services/GTMService";

// Round category tile for the "Shop by category" rail.
class CategoryHorizontalTilePart extends React.Component {
  handleEventClick = () => {
    if (!this.props.sendEvent) return;
    gtmService.event(
      "Navigation",
      "Top Level Categories Banner on Detail Page",
      this.props.isBottom ? "bottom" : "top"
    );
  };

  render() {
    const {
      props: { classes, category },
      handleEventClick
    } = this;

    return (
      <Link
        to={getProductsPageUrl(category)}
        onClick={handleEventClick}
        className={classes.tile}
      >
        <span className={classes.disc}>
          <ImageWithLoaderPart
            width="84"
            height="84"
            src={category.image}
            alt=""
            className={classes.image}
          />
        </span>
        <span className={classes.name}>{category.name}</span>
      </Link>
    );
  }
}

CategoryHorizontalTilePart.propTypes = {
  category: PropTypes.object.isRequired,
  sendEvent: PropTypes.bool,
  isBottom: PropTypes.bool
};

export default withCustomStyles(CategoryHorizontalTilePart);
